import React, {Component} from 'react';
import api from '../../services/api';
import Carousel from 'react-bootstrap/Carousel';

export default class Slider extends Component{
   // executa após o componente ser ativado
   componentDidMount (){
      this.loadDados();
   }
   
   // carrega os dados da api... promisse
   loadDados = async () =>{
      const {data} = await api.get('/banner');
      this.setState({ dados: data });
   }
   
   // armazena os dados no estado
   state = {
      dados: [],
   }

   // renderiza o componente 
   render(){
      return ( 
            <Carousel className="mb-5">
            { this.state.dados.map ( dado => (  
               <Carousel.Item key = {dado.id}>
                     <a href={!dado.link_externo ? `./banner/${dado.slug}` : dado.link_externo} target={ dado.link_externo ? '_blank' : '' }>
                        <img className="mx-auto d-block w-100" src={dado.imagem_destacada.guid} alt={dado.title.rendered} />       
                     </a>
               </Carousel.Item>
            )) }
            </Carousel>
      )
   }
}
